import { render, staticRenderFns } from "./FullRegister.vue?vue&type=template&id=482caa2f"
import script from "./FullRegister.vue?vue&type=script&lang=js"
export * from "./FullRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports